var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(-12146 18042)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5304",
    "data-name": "Rectangle 5304",
    width: 24,
    height: 24,
    transform: "translate(12146 -18042)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10330",
    "data-name": "Group 10330",
    transform: "translate(11918.325 -18135.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M16.218,18.564H3.132A3.176,3.176,0,0,1,0,15.362V7.539a.4.4,0,0,1,.611-.352l7.394,4.574a3.165,3.165,0,0,0,3.339,0l7.394-4.574a.4.4,0,0,1,.611.352v7.823a3.177,3.177,0,0,1-3.132,3.2",
    transform: "translate(230 93.948)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M11.645,7.141,17.2,3.687a.369.369,0,0,0-.239-.68H4.419a.369.369,0,0,0-.239.68L9.734,7.141a1.837,1.837,0,0,0,1.912,0",
    transform: "translate(228.986 94.993)",
    fill: "#a1a1b3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.85572520e02f299910093a9826950bdb.svg";
export { ForwardRef as ReactComponent };